/**
 * Poller central — un seul sondage de `/api/status` pour toute l'application.
 *
 * `/api/status` décrit **la machine qui sert la page**, et rien d'autre. Sur
 * un poste local c'est la bonne machine : elle charge les modèles et elle
 * génère, donc ses six champs bougent et le sondage accéléré a un sens.
 *
 * Sur le site hébergé, c'est une VM sans GPU. `is_loading` et
 * `generation_active` y sont faux en permanence — l'accélération à une
 * seconde ne pouvait donc jamais se déclencher — et la seule chose qui serve
 * encore, `generates_here`, ne change pas au cours d'une visite. Répéter la
 * question toutes les cinq secondes, sur le téléphone de chaque visiteur et
 * pour toujours, ne répond à la question de personne. Une réponse suffit ;
 * ce qui parle ensuite, ce sont les événements du job.
 */
import { APIClient } from "../api/client.js";
import { store } from "../state/store.js";

const ACTIVE_MS = 1000;
const IDLE_MS = 5000;
const ERROR_MS = 10000;

let timer: number | undefined;
let stopped = true;

async function tick(): Promise<void> {
	try {
		const status = await APIClient.getStatus();
		store.setState({ status });
		// Cette machine ne génère pas : il n'y a plus rien à en apprendre.
		if (status.generates_here !== true) {
			statusPoller.stop();
			return;
		}
		schedule(status.is_loading || status.generation_active ? ACTIVE_MS : IDLE_MS);
	} catch {
		// Serveur indisponible / redémarrage : réessaie plus tard, sans spam.
		schedule(ERROR_MS);
	}
}

function schedule(delay: number): void {
	if (stopped) return;
	window.clearTimeout(timer);
	timer = window.setTimeout(() => void tick(), delay);
}

export const statusPoller = {
	start(): void {
		if (!stopped) return;
		stopped = false;
		void tick();
	},

	stop(): void {
		stopped = true;
		window.clearTimeout(timer);
	},
};
